var manuals = {
 	partial : $('.manuals-list.partial'),
	searchForm :function(form){

		form.on('submit',function(){
			var $this  = $(this).find('input[name="q"]');			
			var $val  = $this.val();
			manuals.partial.data('q',$val);			
			load_partial(manuals.partial);
			return false;		
		});

		form.find('select').on('change', $.debounce(500, function(){
				var $this  = $(this);				
				var $val  = $this.val();
				$('.manuals-list.partial').each(function(){

					$(this).data('type',$val);				
				
					load_partial( $(this) );
				});
									
			})
		);
		
		form.find('input[name="q"]').on('input', $.debounce(500, function(){
				var $this  = $(this);				
				var $val  = $this.val();
				manuals.partial.data('q',$val);
				$('.manuals-list.partial').each(function(){
					$(this).data('q',$val);
					load_partial( $(this) );
				});
				
				
			})
		); 

		
	}
};